import React, { useEffect } from 'react'
import Layout from './Layout'
import AddButton from './AddButton'
import Calendar from '../icons/Calendar'
import Clock from '../icons/Clock'
import Tick from '../icons/Tick'
import HomeScreenTile from './HomeScreenTile'
import LessonsList from './LessonsList'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { FETCH_LESSONS, SET_LESSONS_TYPE } from '../redux/lessonsReducer'
import Pencil from '../icons/Pencil'
import { Link } from 'react-router-dom'
import SendMessage from '../icons/SendMessage'
import CreateTutorButton from './CreateTutorButton'

type Props = {}

const HomeScreen = (props: Props) => {
  const lessonsType = useSelector((state: RootReducer) => state.lessonsReducer.lessonsType)
  const authState = useSelector((state: RootReducer) => state.authReducer.authState)
  const dispatch = useDispatch()
  const pendingLessonsCount = useSelector((state: RootReducer) => state.lessonsReducer.pending.lessons.length)
  const paymentPendingLessonsCount = useSelector(
    (state: RootReducer) => state.lessonsReducer.payment_pending.lessons.length
  )
  const acceptedLessonsCount = useSelector((state: RootReducer) => state.lessonsReducer.accepted.lessons.length)
  const finishedLessonsCount = useSelector((state: RootReducer) => state.lessonsReducer.finished.lessons.length)
  const role = useSelector((state: RootReducer) => state.tutorReducer.role)
  useEffect(() => {
    if (authState === 'authorized') {
      dispatch(FETCH_LESSONS({ type: 'pending' }))
      dispatch(FETCH_LESSONS({ type: 'accepted' }))
      dispatch(FETCH_LESSONS({ type: 'finished' }))
      dispatch(FETCH_LESSONS({ type: 'payment_pending' }))
    }
  }, [dispatch, authState])
  return (
    <Layout>
      <div className="px-2 ml--2 mr--2">
        <div className="h-10" />
        <div className="flex justify-between items-center">
          <h2 className="text-28 font-semibold text-slateGray font-domine">My Dashboard</h2>
          <div className="flex items-center gap-2">
            {role === 'moderator' && (
              <>
                <Link to="/units" className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer">
                  <div className="text-white w-5 h-5">
                    <Pencil />
                  </div>
                  <div className="text-14 font-semibold text-white">Units</div>
                </Link>
                <CreateTutorButton />
              </>
            )}
            <AddButton />
          </div>
        </div>
        <div className="h-4" />
        <div className="flex justify-between items-center gap-4 flex-wrap">
          <HomeScreenTile
            active={lessonsType === 'accepted'}
            icon={<Calendar />}
            title="Upcoming Lessons"
            subtitle={`${acceptedLessonsCount} Lessons`}
            onClick={() => dispatch(SET_LESSONS_TYPE({ lessonsType: 'accepted' }))}
          />
          <HomeScreenTile
            active={lessonsType === 'pending'}
            icon={<Clock />}
            title="Pending Requests"
            subtitle={`${pendingLessonsCount} Requests`}
            onClick={() => dispatch(SET_LESSONS_TYPE({ lessonsType: 'pending' }))}
          />
          <HomeScreenTile
            active={lessonsType === 'payment_pending'}
            icon={<SendMessage />}
            title="Pending Payments"
            subtitle={`${paymentPendingLessonsCount} Pending`}
            onClick={() => dispatch(SET_LESSONS_TYPE({ lessonsType: 'payment_pending' }))}
          />
          <HomeScreenTile
            active={lessonsType === 'finished'}
            icon={<Tick />}
            title="Completed Lessons"
            subtitle={`${finishedLessonsCount} Lessons`}
            onClick={() => dispatch(SET_LESSONS_TYPE({ lessonsType: 'finished' }))}
          />
        </div>
        <div className="h-4" />
        <LessonsList />
      </div>
    </Layout>
  )
}

export default HomeScreen
